import React, { useState, useEffect } from 'react';

const IdeasModal = ({ fuseSavedData, fuseLoadingData, modalInfo }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalContent, setModalContent] = useState([]);
  const [contentSrc, setContentSrc] = useState('');
  const [currentContent, setCurrentContent] = useState({
    idea_content: '',
    idea_image_url: ''
  });

  // Update currentIndex based on modalInfo
  useEffect(() => {
    setCurrentIndex(modalInfo.index);
  }, [modalInfo]);

  // Update modalContent based on fuseSavedData
  useEffect(() => {
    if (
      fuseSavedData &&
      Array.isArray(fuseSavedData.fuse_ideas) &&
      fuseSavedData.fuse_ideas.length > 0 &&
      Array.isArray(fuseSavedData.fuse_ideas[0].content_ideas)
    ) {
      setModalContent(fuseSavedData.fuse_ideas[0].content_ideas);
      setContentSrc('saved');
    } else {
      setModalContent([]); // Ensure modalContent is always an array
    }
  }, [fuseSavedData]);

  // Update modalContent based on fuseLoadingData
  useEffect(() => {
    // Only proceed if fuseLoadingData has valid data
    if (fuseLoadingData && Object.keys(fuseLoadingData).length > 0) {
      const data = fuseLoadingData[modalInfo.ideaID];

      if (
        data &&
        Array.isArray(data.fuse_ideas) &&
        data.fuse_ideas.length > 0 &&
        Array.isArray(data.fuse_ideas[0].content_ideas)
      ) {
        setModalContent(data.fuse_ideas[0].content_ideas);
        setContentSrc('loaded');
      }
    }
    // Do not update modalContent or contentSrc if fuseLoadingData is empty
  }, [fuseLoadingData]);

  // Handle Previous Button Click
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  // Handle Next Button Click
  const handleNext = () => {
    if (currentIndex < modalContent.length - 1) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  // Update currentContent based on currentIndex and modalContent
  useEffect(() => {
    if (Array.isArray(modalContent) && modalContent.length > 0) {
      const newContent = modalContent[currentIndex];
      if (newContent) {
        setCurrentContent({
          idea_content: newContent.idea_content || '',
          idea_image_url: newContent.idea_image_url || ''
        });
      } else {
        setCurrentContent({
          idea_content: '',
          idea_image_url: ''
        });
      }
    } else {
      setCurrentContent({
        idea_content: '',
        idea_image_url: ''
      });
    }
  }, [currentIndex, modalContent]);

  return (
    <div className="ideas-modal-content">
      <button
        className="prev"
        onClick={handlePrev}
        disabled={currentIndex === 0}
      ></button>
      <div className="idea-main">
        {currentContent.idea_image_url ? (
          <img src={currentContent.idea_image_url} alt="idea" />
        ) : (
          <div className="placeholder-image">No Image Available</div>
        )}
        {contentSrc === 'loaded' ? (
          <p
            dangerouslySetInnerHTML={{ __html: currentContent.idea_content }}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: currentContent.idea_content }}
          />
        )}
      </div>
      <button
        className="next"
        onClick={handleNext}
        disabled={currentIndex >= modalContent.length - 1}
      ></button>
    </div>
  );
};

export default IdeasModal;
